<template>
  <!-- 机器人快捷入口 -->
  <div class="shortcut scroller flex flex-item-center" v-if="showShortcut">
    <div class="shortcut__arrow flex flex-item-center" @click="handleArrow('left')">
      <i class="iconfont icon-arrow-left-bold" />
    </div>
    <div class="shortcut__list flex flex-1" id="access">
      <div class="shortcut__item" @click="handleAccess(item)" v-for="item in config.quickAccess" :key="item.id">
        <img :src="item.picContent" :alt="item.label" />
        <div>{{ item.label }}</div>
      </div>
    </div>
    <div class="shortcut__arrow flex flex-item-center" @click="handleArrow('right')">
      <i class="iconfont icon-arrow-right-bold" />
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed, defineEmits } from 'vue'
const props = defineProps({
  styleConfig: { type: Object, default: () => {} },
  showType: { type: Number, default: 1 }
})
const emit = defineEmits(['quickAccess'])
const config = computed(() => {
  if (props.styleConfig?.quickAccess) {
    return props.styleConfig
  } else {
    return {
      quickAccess: [],
      showQuickAccess: false
    }
  }
})
const showShortcut = computed(() => {
  if (config.value?.showQuickAccess && config.value?.quickAccess.length > 0 && props.showType === 1) {
    return true
  }
  return false
})
// 快捷入口滚动
const handleArrow = (type) => {
  let ele = document.getElementById('access')
  if (type === 'left') {
    ele.scrollLeft = ele.offsetWidth
  } else {
    ele.scrollLeft = -ele.offsetWidth
  }
}
// 机器人快捷入口点击
const handleAccess = (data) => {
  emit('quickAccess', { ...data, menuType: 1 })
}
</script>
<style lang="less" scoped>
.shortcut {
  width: 100%;
  padding: 20px 15px 0;
  box-sizing: border-box;
  &__list {
    overflow-x: auto;
    flex-wrap: nowrap;
    margin: 0 12px;
  }
  &__arrow {
    background-color: #ffffff;
    height: 48px;
    width: 20px;
    border-radius: 4px;
    color: #999999;
    &:hover {
      color: #444444;
    }
  }
  &__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    margin-right: 12px;
    padding: 8px;
    border-radius: 8px;
    width: 72px;
    min-width: 72px;
    box-sizing: border-box;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
      margin-bottom: 4px;
      object-fit: contain;
    }
    div {
      font-size: 12px;
      color: #323232;
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
    }
  }
}
</style>
